import { render, staticRenderFns } from "./custom-message-setting.vue?vue&type=template&id=1939ed8b"
import script from "./custom-message-setting.vue?vue&type=script&lang=js"
export * from "./custom-message-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports